import request from '@/utils/request';
export function login(data) {
  return request({
    withCredentials: true,
    url: '/user/login',
    method: 'post',
    data: data
  });
}
export function getInfo(token) {
  return request({
    url: '/user/info',
    method: 'get',
    params: {
      token: token
    }
  });
}
export function logout() {
  return request({
    url: '/user/logout',
    method: 'post'
  });
}
export function setUserTheme(data) {
  return request({
    url: '/userservice/api/user/changUserTheme',
    method: 'post',
    data: data
  });
}
export function fetchCode() {
  return request({
    url: '/userservice/api/user/getCode',
    method: 'get'
  });
}